/**
 * CSRF token utilities for BFF write operations.
 * The BFF sets a non-HttpOnly `_eid_csrf_v1` cookie on every safe (GET)
 * response; non-GET requests must echo the value back via `X-CSRF-Token`.
 */

const CSRF_COOKIE = '_eid_csrf_v1';
const CSRF_HEADER = 'X-CSRF-Token';

export function getCsrfToken(): string {
  if (typeof document === 'undefined') return '';
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${CSRF_COOKIE}=([^;]+)`));
  return match ? decodeURIComponent(match[1]) : '';
}

export function csrfHeaders(): Record<string, string> {
  const token = getCsrfToken();
  return token ? { [CSRF_HEADER]: token } : {};
}
